export default function SafetySection() {
  return (
    <section id="sicurezza" className="py-20 md:py-28 bg-background-100 relative">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 relative z-10">
        <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-white border border-background-200 mb-6">
          <span className="text-foreground-600 text-sm font-semibold">Sicurezza</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              Itaobuy Spreadsheet &egrave; Sicuro?
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-8">
              Questa &egrave; una delle domande pi&ugrave; frequenti quando si parla di
              <strong> itaobuy spreadsheet</strong>. La sicurezza e l&apos;affidabilit&agrave; dipendono
              da come vengono utilizzate le informazioni disponibili.
            </p>

            <div className="space-y-5">
              {[
                {
                  icon: 'ri-check-double-line',
                  title: 'Controlli di qualit&agrave;',
                  desc: 'I prodotti presenti negli spreadsheet vengono selezionati attraverso criteri di qualit&agrave; per garantire standard elevati.',
                },
                {
                  icon: 'ri-user-star-line',
                  title: 'Attenzione ai venditori',
                  desc: 'Ogni venditore viene valutato in base a recensioni, storico e affidabilit&agrave; complessiva.',
                },
                {
                  icon: 'ri-file-search-line',
                  title: 'Verifica delle informazioni',
                  desc: 'I dati vengono aggiornati regolarmente per garantire informazioni sempre accurate e pertinenti.',
                },
                {
                  icon: 'ri-lightbulb-line',
                  title: 'Ricerca personale',
                  desc: 'Si consiglia sempre di verificare personalmente i dettagli prima di qualsiasi acquisto.',
                },
              ].map((item, i) => (
                <div key={i} className="flex gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 flex-shrink-0">
                    <i className={`${item.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground-950 text-base mb-1" dangerouslySetInnerHTML={{ __html: item.title }}></h4>
                    <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-background-200 p-8 flex flex-col justify-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 mb-6">
              <i className="ri-shield-star-line text-accent-600 text-2xl"></i>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed italic mb-6">
              &quot;Le informazioni presenti nel sito hanno scopo informativo. Prima di effettuare qualsiasi
              acquisto verificare sempre dettagli, condizioni e informazioni aggiornate. Itaobuy Spreadsheet
              &egrave; uno strumento di supporto alla ricerca, non sostituisce la tua valutazione personale.&quot;
            </p>
            <div className="flex flex-wrap gap-3">
              {['Aggiornato 2026', 'Dati Verificati', 'Supporto Italiano', 'Guida Dettagliata'].map((tag, i) => (
                <span key={i} className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium">
                  ✓ {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Very%20faint%20minimalist%20shield%20and%20checkmark%20pattern%20texture%20on%20cream%20background%2C%20extremely%20subtle%20security%20symbols%20watermark%2C%20clean%20trustworthy%20theme%2C%20warm%20sand%20and%20olive%20tones%2C%20barely%20visible%20repeating%20elements&width=1200&height=800&seq=itaobuy-safety-v2-bg&orientation=landscape')`,
        }}
      ></div>
    </section>
  );
}